import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Details = ({ setValue, value }) => {
  // setHighlightDesc(value);
  const toolbarOptions = [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    // [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ align: [] }],
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    ["link", "image"],
    ["clean"], // remove formatting button
  ];
  return (
    <div>
      <ReactQuill
        modules={{ toolbar: toolbarOptions }}
        value={value}
        placeholder="Write something awesome..."
        // className="h-[150px] mb-[100px]"
        onChange={setValue}
      />
    </div>
  );
};

export default Details;
